import RouterLink, { LinkProps as RouterLinkProps } from 'next/link'
import React from 'react'

import {
  Link as MuiLink,
  LinkProps as MuiLinkProps,
  makeStyles
} from '@material-ui/core'

const useStyles = makeStyles(
  {
    link: {
      fontWeight: 700
    }
  },
  {
    name: 'Link'
  }
)

type Props = {
  href: string
  as?: RouterLinkProps['as']
}

type LinkProps = MuiLinkProps & Props

const Link: React.FC<LinkProps> = ({ href = '/', as, children, ...props }) => {
  const s = useStyles()

  return (
    <RouterLink href={href} passHref as={as}>
      <MuiLink color="secondary" className={s.link} {...props}>
        {children}
      </MuiLink>
    </RouterLink>
  )
}

export default Link
